/**
 * Returns a human readable formatted number with a given number of digits. if the number ends in a
 * 0 after the decimal point, it will not return the digit.
 * @param {number} val the number to format.
 */
export default function (val, digits = 2) {
  return +(val.toFixed(digits));
}
